export enum ChatMessageOriginators {
  LLM = 'LLM',
  METADATA = 'METADATA',
  USER = 'USER',
}
